@if(filter && filter.visible) {
    <div class="filter-view">
        <div class="filter-header" (click)="showFFilter()" [ngClass]="{'selected': filter.open}">
            {{'propertyGroup.' + filter.groupName | translate}}
        </div>
        <div class="filter-content" [ngClass]="{'show': filter.open}">
            @if(filter.filters) {
                <div class="sub-filter-bar">
                    @for (f of filter.filters; track f) {
                        @if(f.visible) {
                            @if((f.name !== 'sport' || showSport) && (f.name !== 'product_type' || showProductType)) {
                                <div class="sub-filter-wrapper">
                                    <div class="entry-header"><span class="name"> {{'property.' + f.name | translate}}</span>
                                        @if(blocked) {
                                            <span class="smallSpinner loading">
                                            <span class="spinner-wrapper">
                                                <span class="spinner"></span>
                                            </span>
                                        </span>
                                        }
                                    </div>
                                    <div class="sub-filter">
                                        @for(sf of f.values; track sf) {
                                            @if(sf.occurrences) {
                                                <div class="entry" (click)="subfilterStateChanged(f, sf)" [ngClass]="{'selected': sf.active, 'blocked': blocked}">
                                                    <span class="value"> {{'property.' + f.name + '.' + sf.value | translate}}</span><span class="count">{{sf.occurrences}}</span>
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                            }

                        }
                    }
                </div>
            }
        </div>
    </div>
}

